import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09b0960e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center"} }, "Список пуст", -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Настройка отображения таблицы")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Выбор отображаемых колонок таблицы", -1))
const _hoisted_12 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { style: {"margin":"0 10px 0 0"} }, "Количество строк на странице", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_SearchDate = _resolveComponent("SearchDate")!
  const _component_Column = _resolveComponent("Column")!
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_SearchSelect = _resolveComponent("SearchSelect")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_XDataTable = _resolveComponent("XDataTable")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_XModal = _resolveComponent("XModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_XDataTable, {
      ref: "XDataTable",
      filters: $data.filters,
      "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (($data.filters) = $event)),
      paginator: $data.paginator,
      "onUpdate:paginator": _cache[3] || (_cache[3] = ($event: any) => (($data.paginator) = $event)),
      "total-rows-count": $data.totalRowsCount,
      class: "tablePage",
      onNeedGetTableItems: _cache[4] || (_cache[4] = ($event: any) => ($options.getTableRows(true)))
    }, {
      toolBarLeftSideLeftOfRefresh: _withCtx(() => [
        _renderSlot(_ctx.$slots, "toolBarLeftSideLeftOfRefresh", {}, undefined, true)
      ]),
      toolBarLeftSideRightOfRefresh: _withCtx(() => [
        _renderSlot(_ctx.$slots, "toolBarLeftSideRightOfRefresh", {}, undefined, true),
        _createVNode(_component_Button, {
          class: "p-button-outlined ml-2",
          icon: "fas fa-cog",
          label: "Настроить таблицу",
          onClick: $options.showColsModal
        }, null, 8, ["onClick"])
      ]),
      toolBarRightSide: _withCtx(() => [
        _renderSlot(_ctx.$slots, "toolBarRightSide", {}, undefined, true)
      ]),
      DataTable: _withCtx(() => [
        _createVNode(_component_DataTable, {
          ref: "Table",
          loading: $data.tableLoading,
          paginator: false,
          rows: 20,
          value: $data.tableItems,
          class: "dataTable",
          lazy: "",
          removableSort: "",
          onRowReorder: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('rowReorder', $event))),
          responsiveLayout: "scroll",
          selectionMode: "single",
          onSort: $options.sort,
          onRowClick: _cache[1] || (_cache[1] = ($event: any) => ($options.tableItemsClick($event)))
        }, {
          empty: _withCtx(() => [
            _hoisted_1
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.columns, (columnItem, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                (columnItem?.type ==='dateRange')
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 0,
                      field: columnItem.column,
                      sortable: true,
                      style: _normalizeStyle(columnItem.style)
                    }, {
                      header: _withCtx(() => [
                        _createVNode(_component_SearchDate, {
                          modelValue: $data.filters[columnItem.column],
                          "onUpdate:modelValue": ($event: any) => (($data.filters[columnItem.column]) = $event),
                          label: columnItem.label
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
                      ]),
                      body: _withCtx((slotProps) => [
                        (columnItem?.options?.showTime === false)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.dateToDMY(slotProps.data?.[columnItem.column] * 1000)), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($options.getDateTimeString(slotProps.data?.[columnItem.column], columnItem?.options?.showTimePassedFrom)), 1))
                      ]),
                      _: 2
                    }, 1032, ["field", "style"]))
                  : (columnItem?.type ==='text')
                    ? (_openBlock(), _createBlock(_component_Column, {
                        key: 1,
                        field: columnItem.column,
                        sortable: true,
                        style: _normalizeStyle(columnItem.style)
                      }, {
                        header: _withCtx(() => [
                          (columnItem?.options?.showTextInsteadOfControlInHeader)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(columnItem.label), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(_component_SearchInput, {
                                  modelValue: $data.filters[columnItem.column],
                                  "onUpdate:modelValue": ($event: any) => (($data.filters[columnItem.column]) = $event),
                                  "autofill-name": '_table_'+columnItem.column,
                                  label: columnItem.label
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "autofill-name", "label"])
                              ]))
                        ]),
                        body: _withCtx((slotProps) => [
                          (columnItem?.options?.transformData === 'bytesToHumanPresent')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(this.bytesToHumanPresent(slotProps.data?.[columnItem.column])), 1))
                            : (columnItem?.options?.transformData === 'trim')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.trimmedString(slotProps.data?.[columnItem.column], columnItem?.options?.transformDataOptions?.length)), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(slotProps.data?.[columnItem.column]), 1))
                        ]),
                        _: 2
                      }, 1032, ["field", "style"]))
                    : (columnItem?.type ==='select')
                      ? (_openBlock(), _createBlock(_component_Column, {
                          key: 2,
                          field: columnItem.column,
                          sortable: true,
                          style: _normalizeStyle(columnItem.style)
                        }, {
                          header: _withCtx(() => [
                            _createVNode(_component_SearchSelect, {
                              modelValue: $data.filters[columnItem.column],
                              "onUpdate:modelValue": ($event: any) => (($data.filters[columnItem.column]) = $event),
                              label: columnItem?.label,
                              options: columnItem?.options?.items,
                              "option-label": "title",
                              "option-value": "value"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "options"])
                          ]),
                          body: _withCtx((slotProps) => [
                            _createElementVNode("div", {
                              innerHTML: (columnItem?.options?.items) ? columnItem?.options?.items.find(item => item?.value === slotProps.data?.[columnItem.column])?.title : ''
                            }, null, 8, _hoisted_9)
                          ]),
                          _: 2
                        }, 1032, ["field", "style"]))
                      : _createCommentVNode("", true)
              ]))
            }), 128)),
            _renderSlot(_ctx.$slots, "tableColumns", { filters: $data.filters }, undefined, true)
          ]),
          _: 3
        }, 8, ["loading", "value", "onSort"])
      ]),
      _: 3
    }, 8, ["filters", "paginator", "total-rows-count"]),
    _createVNode(_component_XModal, { ref: "XModal" }, {
      header: _withCtx(() => [
        _hoisted_10
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "p-button-outlined",
          icon: "fa-solid fa-check",
          label: "Закрыть",
          onClick: $options.saveTableSettings
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _hoisted_11,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.colsVisibilityTitles, (title, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "mb-2"
          }, [
            _createVNode(_component_Checkbox, {
              modelValue: $data.colsVisibilityValues[index],
              "onUpdate:modelValue": ($event: any) => (($data.colsVisibilityValues[index]) = $event),
              binary: true,
              value: index,
              name: "colsVisibilityValues"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "value"]),
            _createElementVNode("label", null, "  " + _toDisplayString((index + 1)) + "  " + _toDisplayString(title), 1)
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_InputNumber, {
            modelValue: $data.paginator.limit,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.paginator.limit) = $event)),
            "allow-empty": false,
            max: 200,
            min: 1,
            "show-buttons": ""
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}